
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"5","viewBox":"0 0 13 8","fill":"none","xmlns":"http://www.w3.org/2000/svg","transform":"rotate(180)"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.635.367l4.728 4.728L11.091.367l1.272 1.272-6 6-6-6L1.635.367z","fill":"#748190"}})])
          )
        }
      }
    